import { ChevronDown } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export type ReportWindowOption = 'expired' | '1-3' | '4-7' | '8+';

interface ReportWindowFilterProps {
  value: ReportWindowOption[];
  onChange: (value: ReportWindowOption[]) => void;
}

const options: { value: ReportWindowOption; label: string }[] = [
  { value: 'expired', label: 'Expired' },
  { value: '1-3', label: '1-3 days' },
  { value: '4-7', label: '4-7 days' },
  { value: '8+', label: '8+ days' },
];

export function ReportWindowFilter({ value, onChange }: ReportWindowFilterProps) {
  const handleToggle = (option: ReportWindowOption) => {
    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option));
    } else {
      onChange([...value, option]);
    }
  };

  const selectedCount = value.length;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="justify-between">
          <span>Report Download Window</span>
          {selectedCount > 0 && (
            <span className="ml-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#131313] text-[12px] text-white">
              {selectedCount}
            </span>
          )}
          <ChevronDown className="ml-2 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[200px]">
        {options.map((option) => (
          <div
            key={option.value}
            role="menuitemcheckbox"
            aria-checked={value.includes(option.value)}
            tabIndex={0}
            className="flex w-full cursor-pointer items-center gap-2 px-2 py-2 hover:bg-muted"
            onClick={() => handleToggle(option.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleToggle(option.value);
              }
            }}
          >
            <Checkbox checked={value.includes(option.value)} tabIndex={-1} />
            <span>{option.label}</span>
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
